import { BoolEquals, Rule, Or } from '@vendasta/automata';
import { ParameterPath } from './billing-purchase-success.constants';

export function path(): string {
  return '{.approved}';
}

export enum ApprovalState {
  ANY = 1,
  APPROVED,
  NOT_APPROVED,
}

export function rule(isApproved: ApprovalState): Rule {
  switch (isApproved) {
    case ApprovalState.ANY:
      return new Or([new BoolEquals(ParameterPath.Approved, true), new BoolEquals(ParameterPath.Approved, false)]);
    case ApprovalState.APPROVED:
      return new BoolEquals(ParameterPath.Approved, true);
    case ApprovalState.NOT_APPROVED:
      return new BoolEquals(ParameterPath.Approved, false);
  }
}
